import React from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface QuantityStepperProps {
    value: number;
    productName: string;
    disabled?: boolean;
    valueClassName?: string;
    size?: "default" | "sm";
    onDecrement: () => void;
    onIncrement: () => void;
    onChange: (value: number) => void;
}

export const QuantityStepper = ({
    value,
    productName,
    disabled,
    valueClassName,
    size = "default",
    onDecrement,
    onIncrement,
    onChange,
}: QuantityStepperProps) => {
    const isSm = size === "sm";
    return <div className={cn(
        "flex items-center rounded-[8px] border border-transparent bg-[#f4f6f5]",
        isSm ? "gap-2 p-[1.5px]" : "gap-1.6 p-[3px]",
    )}>
        <Button
            type="button"
            variant="ghost"
            size="icon"
            className={cn(
                "rounded-[6px] bg-white text-green-700 shadow-sm hover:bg-[#f7faf8] hover:text-green-700 hover:shadow-md disabled:cursor-not-allowed disabled:bg-white disabled:text-muted-foreground disabled:shadow-none",
                isSm ? "h-[18px] w-[18px] text-xs" : "h-[34px] w-[34px] rounded-[8px]",
            )}
            onClick={onDecrement}
            disabled={disabled || value <= 0}
            aria-label="Remover uma unidade"
        >
            −
        </Button>
        <Input
            type="number"
            inputMode="numeric"
            value={value}
            disabled={disabled}
            onChange={e => onChange(Number(e.target.value || 0))}
            aria-label={`Quantidade do pedido — ${productName}`}
            className={cn(
                "border-0 bg-transparent p-0 text-center font-semibold leading-none text-foreground focus-visible:ring-0 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
                isSm ? "h-[18px] w-[26px] text-xs" : "h-[34px] w-[44px] text-base",
                valueClassName,
            )}
        />
        <Button
            type="button"
            variant="ghost"
            size="icon"
            className={cn(
                "rounded-[6px] bg-white text-green-700 shadow-sm hover:bg-[#f7faf8] hover:text-green-700 hover:shadow-md disabled:cursor-not-allowed disabled:bg-white disabled:text-muted-foreground disabled:shadow-none",
                isSm ? "h-[18px] w-[18px] text-xs" : "h-[34px] w-[34px] rounded-[8px]",
            )}
            onClick={onIncrement}
            disabled={disabled}
            aria-label="Adicionar uma unidade"
        >
            +
        </Button>
    </div>;
};
